import ProductionFormatAPIService from 'frontcore/data/production-format/ProductionFormatAPIService'
import { computed, ComputedRef, reactive } from 'vue'
import { defineStore } from 'pinia'
import { ProductionFormat } from 'frontcore/domain/production-format/types'
import { PROMISE_STATUS } from 'frontcore/constants'
import { Proxy } from 'frontcore/constants/proxy'


interface IProductsState {
  products: Proxy<ProductionFormat[]>
}

interface IProductsStore {
  fetchProductionFormats: (force: boolean) => Promise<void>
  products: ComputedRef<ProductionFormat[]>
  areProductionFormatsLoaded: ComputedRef<boolean>
  areProductionFormatsCalled: ComputedRef<boolean>
}

export const useProductionFormatStore = defineStore('ProductionFormats', (): IProductsStore => {
  const { fetch } = new ProductionFormatAPIService()

  const state = reactive<IProductsState>({
    products: {
      data: [],
      promise: Promise.resolve([]),
      promiseStatus: PROMISE_STATUS.notStarted,
    },
  })

  const fetchProductionFormats = async (force = false) => {
    if (state.products.promiseStatus === PROMISE_STATUS.notStarted || force) {
      state.products.promise = fetch()
      state.products.promiseStatus = PROMISE_STATUS.pending
    }

    try {
      if (state.products.data.length === 0 || force) {
        const people = await state.products.promise
        state.products.data = people
        state.products.promiseStatus = PROMISE_STATUS.complete
        
      }
    } catch (e) {
      state.products.promiseStatus = PROMISE_STATUS.notStarted
    }
  }

  const products = computed(() => state.products.data)

  const areProductionFormatsCalled = computed(() => state.products.promiseStatus !== PROMISE_STATUS.notStarted)
  const areProductionFormatsLoaded = computed(() => state.products.promiseStatus === PROMISE_STATUS.complete)

  return {
    fetchProductionFormats,
    products,
    areProductionFormatsLoaded,
    areProductionFormatsCalled,
  }
})
